/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramConnectionsUserControllerFindAllQueryResponse,
  TelegramConnectionsUserControllerFindAllQueryParams,
  TelegramConnectionsUserControllerFindAll401,
} from '../../types/TelegramConnectionsUserControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramConnectionsUserFindAll } from '../../methods/telegramConnectionsUserFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramConnectionsUserFindAllQueryKey = (params: TelegramConnectionsUserControllerFindAllQueryParams) =>
  [{ url: '/api/user/telegram/connections' }, ...(params ? [params] : [])] as const;

export type TelegramConnectionsUserFindAllQueryKey = ReturnType<typeof telegramConnectionsUserFindAllQueryKey>;

export function telegramConnectionsUserFindAllQueryOptions(
  params: TelegramConnectionsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramConnectionsUserFindAllQueryKey(params);
  return queryOptions<
    TelegramConnectionsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramConnectionsUserControllerFindAll401>,
    TelegramConnectionsUserControllerFindAllQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramConnectionsUserFindAll(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/connections}
 */
export function useTelegramConnectionsUserFindAll<
  TData = TelegramConnectionsUserControllerFindAllQueryResponse,
  TQueryData = TelegramConnectionsUserControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramConnectionsUserFindAllQueryKey,
>(
  params: TelegramConnectionsUserControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramConnectionsUserControllerFindAllQueryResponse,
        ResponseErrorConfig<TelegramConnectionsUserControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramConnectionsUserFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramConnectionsUserFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramConnectionsUserControllerFindAll401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
